/* eslint-disable react-hooks/exhaustive-deps */
import styled from "@emotion/styled";
import { Autocomplete, Box, Button, Checkbox, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, Link, TextField, Tooltip, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import TagIcon from '@mui/icons-material/Tag';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SellIcon from '@mui/icons-material/Sell';
import { ArrowBack, ContentCopyOutlined, CopyAll, DeleteOutline, DeleteOutlineOutlined, Edit, EditOutlined } from "@mui/icons-material";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TableViewIcon from '@mui/icons-material/TableView';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import React, { useCallback, useMemo, useState } from "react";
import DataTable from "../../../common/DataTable";
import ColumnPanel from "../../../common/ColumnPanel";
import { DepartColumnDefs, RoomColumnDefs } from "./columnDefs";
import { LoadingPage } from "../../../common/LoadingPage";
import CreateModule from "./CreateModule";
import { apiRequest } from "../../../common/common";
import { useSelector } from "react-redux";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { ArchitecturalCode, BasicAccess, ConnectionType, Discontinues, DissipationType, DrainLocation, ElectricalPhase, EnterpriseAccess, GasLocation, GasType, getSize, getWeight, Mounting, Network, PlugType, ProductType, Responsibility, Shielding, StandardAccess, TemplateType, Units, VentType, VoltageType } from "../../../common/const";
import CommonCopy from "./CommonCopy";
import ImageModal from "../Catalog/ProductModule/ImageModel";
import ImageIcon from '@mui/icons-material/Image';
import CreateItem from "./CreateItem";
import { useEffect } from "react";
import moment from "moment";
import ColumnHeader from "../Catalog/columnHeader";
import AddItemInProject from "../Catalog/addItemInProject";

const DemoTypo = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  textAlign: 'justify'
}));

const DemoTypo1 = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 'bold'
}));

const DividerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  minHeight: 50
}));

const DemoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 10
}));

const DemoBox1 = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 10
}));

export default function Templates({
  fromProject,
  setSelectedProduct,
  innerLabel
}) {
  const { user, roles } = useSelector((state) => state.users);
  const isUser = roles.find((a) => a.id === user?.role_id);
  const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
  const [gridApi, setGridApi] = useState(null);
  const [rowsPerPage, setRowPerPage] = useState(10);
  const [searchingText, setSearchText] = useState(null);
  const [dataLoading, setDataLoding] = useState(false);
  const [publicTemplate, setPublicTemplate] = useState([]);
  const [organizationTemplate, setOrganizationTemplate] = useState([]);
  const [privateTemplate, setPrivateTemplate] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState([]);
  const [selectedDep, setSelectedDep] = useState([]);
  const [open, setOpen] = useState(false);
  const [openCopy, setOpenCopy] = useState(false);
  const [isTemplate, setIsTemplate] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [templateItem, setTemplateItem] = useState(null);
  const [listItem, setListItem] = useState(null);
  const [imageOpen, setImageOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [productColumn, setProductColumn] = useState(RoomColumnDefs);
  const [settingData, setSettingData] = useState([]);
  const [copyOpen, setCopyOpen] = useState(false);
  const [templateType, setTemplateType] = useState(TemplateType[1]?.value);
  const [isChecked, setIsChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [returnedData, setReturnedData] = useState([]);
  const [catalogOpen, setCatalogOpen] = useState(false);

  const templates = [
    {
      label: "Mvedas", //Medical
      key: "public",
      data: publicTemplate,
    },
    {
      label: "Organization",
      key: "organization",
      data: organizationTemplate,
    },
    {
      label: "Personal",
      key: "personal",
      data: privateTemplate,
    },
  ];

  const [toggleStates, setToggleStates] = useState(
    templates.reduce((acc, template) => {
      acc[template.label] = { open: false, nested: {} };
      return acc;
    }, {})
  );

  const handleToggle = (label, key, nestedLabel) => {
    setToggleStates((prevState) => {
      const updatedState = { ...prevState };
      if (nestedLabel) {
        updatedState[label].nested[nestedLabel] = !updatedState[label].nested[nestedLabel];
      } else {
        updatedState[label].open = !updatedState[label].open;
        if (!updatedState[label].open) {
          updatedState[label].nested = {};
        }
        if (prevState[label].open) {
          getInitialData(1, key);
        }
      }
      return updatedState;
    });
    setTemplateItem(null);
  };

  const onPaginationChanged = (event) => {
    if (event.api) {
      const newPageSize = event.api.paginationGetPageSize();
      setRowPerPage(newPageSize);
    }
  };

  useEffect(() => {
    if (productColumn?.length > 0 && gridApi) {
      const columnState = gridApi?.getColumnState()?.map(state => {
        const columnConfig = productColumn.find((c) => c.colId === state.colId || c.field === state.colId);
        if (columnConfig) {
          if (columnConfig.pinned !== state.pinned) {
            state.pinned = columnConfig.pinned ? columnConfig.pinned : null;
          }
        }

        return state;
      });
      gridApi?.applyColumnState({ state: columnState });
      gridApi?.refreshHeader();
    }
  }, [productColumn]);

  const getData = async () => {
    try {
      const response = await apiRequest('get', `/user-view?userId=${user?.user_id}&type=items&pageNo=1&pageSize=50`);
      const { data } = response.data;
      if (data?.length > 0) {
        if (data?.find((a) => a.is_pinned === true)?.columns) {
          setProductColumn([...productColumn.slice(0, 3), ...data?.find((a) => a.is_pinned === true)?.columns]);
        }
        setSettingData(data);
      } else {
        setSettingData([]);
      }
    } catch (error) {
      setDataLoding(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  const toolPanel = useMemo(() => [
    templateItem !== null && {
      id: 'custom1',
      labelDefault: 'Columns',
      iconKey: "columns",
      toolPanel: ColumnPanel,
      width: 450,
      toolPanelParams: {
        columns: productColumn?.slice(3, 89),
        setColumns: (column) => {
          setProductColumn([...productColumn.slice(0, 3), ...column]);
        },
        settingData,
        fetchData: () => {
          if (user?.user_id) {
            getData();
          }
        },
        type: "items",
        defaultVisibleColumns: RoomColumnDefs?.slice(3, 89),
        columnOrder: productColumn?.slice(3, 89)
      }
    }
  ], [templateItem, settingData, productColumn]);

  useEffect(() => {
    if (user?.user_id) {
      localStorage.removeItem('projectData');
      localStorage.removeItem('itemData');
      getData();
    }
  }, [user?.user_id]);

  const onSelectChanged = (value) => {
    if (gridApi) {
      if (value === 1) {
        const selectedNodes = gridApi.getSelectedNodes();
        gridApi.forEachNode((node) => {
          selectedNodes.push(node);
          node.setSelected(true);
        });
        const uniqueNodesSet = new Set(selectedNodes);
        const uniqueNodesArray = Array.from(uniqueNodesSet);
        const data = uniqueNodesArray.map((node) => node.data.item_template_id);
        setSelectedData(data);
      } else if (value === 2) {
        const selectedNodes = gridApi.getSelectedNodes();
        selectedNodes.forEach((node) => node.setSelected(false));
      }
    }
  };

  const removeAllColumn = () => {
    if (gridApi) {
      setSelectedData([]);
      setIsChecked(false);
      setIndeterminate(false);
      const selectedNodes = gridApi.getSelectedNodes();
      selectedNodes.forEach((node) => node.setSelected(false));
    }
  };

  const updatedColumns = useMemo(() => {
    let column = [];
    if (templateItem !== null) {
      column = productColumn;
      if (column.length > 0) {
        return column.map((col) => {
          switch (col.field) {
            case '':
              return {
                ...col,
                headerComponent: ColumnHeader,
                headerComponentParams: {
                  onSelectChanged,
                  removeAllColumn,
                  isChecked,
                  setIsChecked,
                  indeterminate,
                  setIndeterminate,
                },
              };
            case 'model':
              return {
                ...col,
                flex: 1,
                minWidth: 200,
                cellRenderer: (params) => {
                  if (params?.data?.product?.model !== 'null') {
                    return (
                      <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        onClick={() => window.open(`/app/catalog/product/tm/${params?.data.product?.product_id}`, '_blank')}
                      >
                        {params?.data?.product?.model ? params?.data?.product?.model : '--'}
                      </Link>
                    )
                  }
                  return '';
                },
              };
            case 'catalog':
              return {
                ...col,
                flex: 1,
                minWidth: 150,
                cellRenderer: (params) => {
                  if (params?.data?.catalog !== 'null') {
                    return (
                      params?.data?.catalog ? params?.data?.catalog : ''
                    )
                  }
                  return '';
                },
              };
            case 'creationdate':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.["created_at"] ? moment(params?.data?.["created_at"]).format('DD-MM-YYYY') : '--'}</span>
                  )
                },
              };
            case 'templatetype':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.department?.type ? TemplateType.find((a) => a.value === params?.data?.department?.type)?.name : '--'}</span>
                  )
                },
              };
            case 'department':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.department?.department_name ? params?.data?.department?.department_name : '--'}</span>
                  )
                },
              };
            case 'bixpand_id':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product?.["numaric_sku"]) {
                    return (
                      <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        onClick={() => window.open(`/app/catalog/product/tm/${params?.data.product?.product_id}`, '_blank')}
                      >
                        {params?.data?.product?.is_customer_product ? `C-${params?.data?.product?.alternate_id}` :
                          params?.data?.category?.["sku_no"] ? `${params?.data?.category?.["sku_no"]}${params?.data?.sub_category?.["sku_no"]}-${String(params?.data?.["numaric_sku"]).padStart(3, '0')}` : '--'
                        }
                      </Link>
                    );
                  } else {
                    return (
                      <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        onClick={() => window.open(`/app/catalog/product/tm/${params?.data.product?.product_id}`, '_blank')}
                      >
                        {params?.data?.product?.is_customer_product ? `C-${params?.data?.product?.alternate_id}` : `${params?.data?.product?.category?.["sku_no"]}${params?.data?.product?.sub_category?.["sku_no"]}-${String(0).padStart(3, '0')}`}
                      </Link>
                    );
                  }
                },
              };
            case 'cad_id':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product?.["numaric_sku"]) {
                    return (
                      <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        onClick={() => window.open(`/app/catalog/product/tm/${params?.data?.product.product_id}`, '_blank')}
                      >
                        {params?.data?.product?.is_customer_product ? `C-${params?.data?.product?.alternate_id}` : `${params?.data?.product?.category?.prefix}${params?.data?.product?.sub_category?.prefix}-${String(params?.data?.product?.["numaric_sku"]).padStart(3, '0')}`}
                      </Link>
                    );
                  } else {
                    return (
                      <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        onClick={() => window.open(`/app/catalog/product/tm/${params?.data?.product.product_id}`, '_blank')}
                      >
                        {params?.data?.product?.is_customer_product ? `C-${params?.data?.product?.alternate_id}` : params?.data?.product?.category?.prefix ? `${params?.data?.product?.category?.prefix}${params?.data?.product?.sub_category?.prefix}-${String(params?.data?.product?.["numaric_sku"]).padStart(3, '0')}` : '--'}
                      </Link>
                    );
                  }
                },
              };
            case 'images':
              return {
                ...col,
                flex: 1,
                minWidth: 75,
                headerName: 'Image',
                cellRenderer: (params) => {
                  if (params?.data?.product?.images?.[0]?.sortUrl) {
                    return (
                      <Box sx={{ height: '100%', width: '30px', display: 'flex', justifyContent: 'center' }}>
                        <img
                          src={params?.data?.product?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.product?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : ''}
                          style={{ height: '100%', cursor: 'pointer' }}
                          onClick={() => {
                            setImageOpen(true);
                            setImageSrc(params?.data?.product?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.product?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : '');
                          }}
                          alt="img"
                        />
                      </Box>
                    );
                  }
                  return (
                    <ImageIcon style={{ color: 'lightgray' }} />
                  );
                },
              };
            case 'category':
              return {
                ...col,
                flex: 1,
                minWidth: 175,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.category?.name}</span>
                    );
                  }
                  return '';
                },
              };
            case 'sub_category':
              return {
                ...col,
                flex: 1,
                minWidth: 200,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.["sub_category"]?.name}</span>
                    );
                  }
                  return '';
                },
              };
            case 'Description':
              return {
                ...col,
                flex: 1,
                minWidth: 275,
                cellRenderer: (params) => {
                  return (
                    <span>{`${params?.data?.product?.category?.name ? params?.data?.product?.category?.name : ''}, ${params?.data?.product?.["sub_category"]?.name ? params?.data?.product?.["sub_category"]?.name : ''}`}</span>
                  );
                },
              };
            case 'manufacturer':
              return {
                ...col,
                flex: 1,
                minWidth: 200,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.manufacturer?.name ? params?.data?.product?.manufacturer?.name : ''}</span>
                  );
                },
              };
            case 'vendor':
              return {
                ...col,
                flex: 1,
                minWidth: 200,
                cellRenderer: (params) => {
                  if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas') {
                    return (
                      <span>{params?.data?.vendor?.name ? params?.data?.vendor?.name : ''}</span>
                    );
                  } else {
                    return (
                      <span>{params?.data?.product?.vendor?.name ? params?.data?.product?.vendor?.name : ''}</span>
                    );
                  }
                },
              };
            case 'description':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.product?.description ? params?.data?.product?.description : ''}>
                      <span>{params?.data?.product?.description ? params?.data?.product?.description.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'list_price':
              return {
                ...col,
                flex: 1,
                minWidth: 125,
                cellRenderer: (params) => {
                  if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas') {
                    return (
                      <span>{`₹ ${params?.data?.list_price ? Intl.NumberFormat('en-IN').format(params?.data?.list_price) : 0}`}</span>
                    );
                  } else {
                    return (
                      <span>{`₹ ${params?.data?.product?.list_price ? Intl.NumberFormat('en-IN').format(params?.data?.product?.list_price) : 0}`}</span>
                    );
                  }
                },
                editable: (params) => {
                  return (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas') ? true : false
                },
                cellStyle: (params) => {
                  if ((TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas')) {
                    return {
                      backgroundColor: 'lightgray',
                      border: 'none',
                    }
                  }
                  return {
                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                  };
                },
              };
            case 'quantity':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.quantity ? params?.data?.quantity : 0}</span>
                  );
                },
                editable: (params) => {
                  if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name === 'Mvedas' && ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) {
                    return true
                  } else if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) {
                    return true
                  } else {
                    return false
                  }
                },
                cellStyle: (params) => {
                  if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name === 'Mvedas' && ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) {
                    return {
                      backgroundColor: 'lightgray',
                      border: 'none',
                    }
                  } else if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) {
                    return {
                      backgroundColor: 'lightgray',
                      border: 'none',
                    }
                  } else {
                    return {
                      background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                    };
                  }
                },
              };
            case 'totalcost':
              return {
                ...col,
                flex: 1,
                minWidth: 125,
                cellRenderer: (params) => {
                  if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas') {
                    return (
                      <span>{`₹ ${params?.data?.list_price ? Intl.NumberFormat('en-IN').format(params?.data?.list_price * params?.data?.quantity) : 0}`}</span>
                    );
                  } else {
                    return (
                      <span>{`₹ ${params?.data?.product?.list_price ? Intl.NumberFormat('en-IN').format(params?.data?.product?.list_price * params?.data?.quantity) : 0}`}</span>
                    );
                  }
                },
              };
            case 'notes':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.product?.notes ? params?.data?.product?.notes : ''}>
                      <span>{params?.data?.product?.notes ? params?.data?.product?.notes.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'discontinued':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{Discontinues.find((a) => a.value === params?.data?.product?.discontinued)?.name || '--'}</span>
                  );
                },
              };
            case 'type':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{ProductType.find((a) => a.value === params?.data?.product?.type)?.name || '--'}</span>
                  );
                },
              };
            case 'furnish_responsibility':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas') {
                    return (
                      <span>{Responsibility.find((a) => a.value === params?.data?.furnish_responsibility)?.name || '--'}</span>
                    );
                  } else {
                    return (
                      <span>{Responsibility.find((a) => a.value === params?.data?.product?.furnish_responsibility)?.name || '--'}</span>
                    );
                  }
                },
              };
            case 'install_responsibility':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas') {
                    return (
                      <span>{Responsibility.find((a) => a.value === params?.data?.install_responsibility)?.name || '--'}</span>
                    );
                  } else {
                    return (
                      <span>{Responsibility.find((a) => a.value === params?.data?.product?.install_responsibility)?.name || '--'}</span>
                    );
                  }
                },
              };
            case 'architectural_code':
              return {
                ...col,
                flex: 1,
                minWidth: 110,
                cellRenderer: (params) => {
                  if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas') {
                    return (
                      <span>{ArchitecturalCode.find((a) => a.value === params?.data?.architectural_code)?.name || '--'}</span>
                    );
                  } else {
                    return (
                      <span>{ArchitecturalCode.find((a) => a.value === params?.data?.product?.architectural_code)?.name || '--'}</span>
                    );
                  }
                },
              };
            case 'lead_time':
              return {
                ...col,
                flex: 1,
                minWidth: 110,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.lead_time || '--'}</span>
                  );
                },
              };
            case 'life_expectancy':
              return {
                ...col,
                flex: 1,
                minWidth: 110,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.life_expectancy || '--'}</span>
                  );
                },
              };
            case 'custom_id_1':
              return {
                ...col,
                flex: 1,
                minWidth: 110,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.custom_id_1 !== null ? params?.data?.product?.custom_id_1 : '--'}</span>
                  );
                },
              };
            case 'custom_id_2':
              return {
                ...col,
                flex: 1,
                minWidth: 110,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.custom_id_2 !== null ? params?.data?.product?.custom_id_2 : '--'}</span>
                  );
                },
              };
            case 'govt_id':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.govt_id !== null ? params?.data?.product?.govt_id : '--'}</span>
                  );
                },
              };
            case 'alternate_id':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.alternate_id !== null ? `C-${params?.data?.product?.alternate_id}` : '--'}</span>
                  );
                },
              };
            case 'inventory_id':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.alternate_id !== null ? params?.data?.product?.inventory_id : '--'}</span>
                  );
                },
              };
            case 'architecturally_significant':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.architecturally_significant !== null ? (params?.data?.product?.architecturally_significant ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'spatially_significant':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.spatially_significant !== null ? (params?.data?.product?.spatially_significant ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'units':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  return (
                    <span>{Units.find((a) => a.value === params?.data?.product?.units)?.name}</span>
                  );
                },
              };
            case 'width':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.width);
                  }
                  return '';
                },
              };
            case 'height':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.height);
                  }
                  return '';
                },
              };
            case 'depth':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.depth);
                  }
                  return '';
                },
              };
            case 'clearance':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.clearance?.left);
                  }
                  return '';
                },
              };
            case 'clearance_right':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.clearance?.right);
                  }
                  return '';
                },
              };
            case 'clearance_back':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.clearance?.back);
                  }
                  return '';
                },
              };
            case 'clearance_front':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.clearance?.front);
                  }
                  return '';
                },
              };
            case 'clearance_top':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.clearance?.top);
                  }
                  return '';
                },
              };
            case 'clearance_bottom':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getSize(params?.data?.product?.units, params?.data?.product?.clearance?.bottom);
                  }
                  return '';
                },
              };
            case 'mouting':
              return {
                ...col,
                flex: 1,
                minWidth: 140,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return <span>{Mounting.find((a) => a.value === params?.data?.product?.mounting)?.name}</span>
                  }
                  return '';
                },
              };
            case 'max_weight':
              return {
                ...col,
                flex: 1,
                minWidth: 140,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getWeight(params?.data?.product?.units, params?.data?.product?.max_weight);
                  }
                  return '';
                },
              };
            case 'ship_weight':
              return {
                ...col,
                flex: 1,
                minWidth: 140,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getWeight(params?.data?.product?.units, params?.data?.product?.ship_weight);
                  }
                  return '';
                },
              };
            case 'operating_weight':
              return {
                ...col,
                flex: 1,
                minWidth: 140,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return getWeight(params?.data?.product?.units, params?.data?.product?.operating_weight);
                  }
                  return '';
                },
              };
            case 'da_complient':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.da_complient !== null ? (params?.data?.product?.da_complient ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'antimicrobial':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.antimicrobial !== null ? (params?.data?.product?.antimicrobial ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'green':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.green !== null ? (params?.data?.product?.green ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'Shielding':
              return {
                ...col,
                flex: 1,
                minWidth: 90,
                cellRenderer: (params) => {
                  return (
                    <span>{Shielding?.find((a) => a.value === params?.data?.product?.Shielding)?.name || '--'}</span>
                  );
                },
              };
            case 'seismic':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.product?.seismic !== null ? (params?.data?.product?.seismic ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'spatial_remarks':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.product?.spatial_remarks ? params?.data?.product?.spatial_remarks : ''}>
                      <span>{params?.data?.product?.spatial_remarks ? params?.data?.product?.spatial_remarks.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'electrical_data':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{VoltageType.find((a) => a.value === params?.data?.product?.electrical_data?.voltageType)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'volts':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.volts ? `${params?.data?.product?.electrical_data?.volts} V` : '--'} </span>
                    );
                  }
                  return '';
                },
              };
            case 'amps':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.amps ? `${params?.data?.product?.electrical_data?.amps} A` : '--'} </span>
                    );
                  }
                  return '';
                },
              };
            case 'watts':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.watts ? `${params?.data?.product?.electrical_data?.watts} W` : '--'} </span>
                    );
                  }
                  return '';
                },
              };
            case 'kva':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.kva ? `${params?.data?.product?.electrical_data?.kva} kVA` : '--'} </span>
                    );
                  }
                  return '';
                },
              };
            case 'hertz':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.hertz ? `${params?.data?.product?.electrical_data?.hertz} Hz` : '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'electric_phase':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{ElectricalPhase.find((a) => a.value === params?.data?.product?.electrical_data?.electricalPhase)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'plug_type':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{PlugType.find((a) => a.value === params?.data?.product?.electrical_data?.plugtype)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'plug_details':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.plugdetail || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'emergency_power':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.emergencyPower ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'remote_transformer':
              return {
                ...col,
                flex: 1,
                minWidth: 105,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.remoteTrans ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'remote_switch':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.electrical_data?.remoteSwitch ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'electrical_remark':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.product?.electrical_data?.electricalRemarks ? params?.data?.product?.electrical_data?.electricalRemarks : ''}>
                      <span>{params?.data?.product?.electrical_data?.electricalRemarks ? params?.data?.product?.electrical_data?.electricalRemarks.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'tech_connection_data':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.tech_connection_data?.isConnection ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'connection_type':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{ConnectionType.find((a) => a.value === params?.data?.product?.tech_connection_data?.connectionType)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'network':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{Network.find((a) => a.value === params?.data?.product?.tech_connection_data?.network)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'technical_remarks':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                cellRenderer: (params) => {
                  if (params?.data?.product?.tech_connection_data?.isConnection) {
                    return (
                      <Tooltip title={params?.data?.product?.tech_connection_data?.techRemarks ? params?.data?.product?.tech_connection_data?.techRemarks : ''}>
                        <span>{params?.data?.product?.tech_connection_data?.techRemarks ? params?.data?.product?.tech_connection_data?.techRemarks.slice(0, 50) : '--'}</span>
                      </Tooltip>
                    )
                  }
                  return '--'
                },
              };
            case 'plumbing_data':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.plumbing_data?.coldWater ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'hot':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.plumbing_data?.hotWater ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'treated':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.plumbing_data?.treatedWater ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'steam':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.plumbing_data?.steam ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'medical_vaccum':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.plumbing_data?.vaccumMedical ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'dental_vaccum':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.plumbing_data?.vaccumDental ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'medical_gas':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.plumbing_data?.medicalgas ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'drain':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.plumbing_data?.drain ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'drain_location':
              return {
                ...col,
                flex: 1,
                minWidth: 90,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{DrainLocation.find((a) => a.value === params?.data?.product?.plumbing_data?.drainLocation)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'gas_type':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{GasType.find((a) => a.value === params?.data?.product?.plumbing_data?.gasType)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'gas_location':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{GasLocation.find((a) => a.value === params?.data?.product?.plumbing_data?.gasLocation)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'plumbing_remarks':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.product?.plumbing_data?.plumbingRemarks ? params?.data?.product?.plumbing_data?.plumbingRemarks : ''}>
                      <span>{params?.data?.product?.plumbing_data?.plumbingRemarks ? params?.data?.product?.plumbing_data?.plumbingRemarks.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'mechanical_data':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.mechanical_data?.vent ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'vent_type':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.mechanical_data?.vent ? (VentType.find((a) => a.value === params?.data?.product?.mechanical_data?.ventType)?.name || '--') : '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'heat_hr':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{params?.data?.product?.mechanical_data?.heatDissipation || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'dissipation_type':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  if (params?.data?.product) {
                    return (
                      <span>{DissipationType.find((a) => a.value === params?.data?.product?.mechanical_data?.dissipationType)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'mechanical_remarks':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.product?.mechanical_data?.mechanicalRemarks ? params?.data?.product?.mechanical_data?.mechanicalRemarks : ''}>
                      <span>{params?.data?.product?.mechanical_data?.mechanicalRemarks ? params?.data?.product?.mechanical_data?.mechanicalRemarks.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            default:
              return col;
          }
        });
      }
    } else if (selectedRoom?.length > 0) {
      column = DepartColumnDefs;
      if (column.length > 0) {
        return column.map((col) => {
          if (col.field === 'room_name') {
            return {
              ...col,
              flex: 1,
              minWidth: 220,
              cellRenderer: (params) => {
                return (
                  <Link
                    style={{ textDecoration: 'none', cursor: 'pointer' }}
                    onClick={() => {
                      setTemplateItem(params?.data);
                    }}
                  >
                    {params?.data?.room_name ? params?.data?.room_name : '--'}
                  </Link>
                )
              },
              editable: (params) => {
                return (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) ? true : false
              },
              cellStyle: (params) => {
                if ((TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code))) {
                  return {
                    backgroundColor: 'lightgray',
                    border: 'none',
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
            };
          }
          if (col.field === 'quantity') {
            return {
              ...col,
              flex: 1,
              minWidth: 120,
              cellRenderer: (params) => {
                return (
                  <span>{params?.data?.quantity}</span>
                )
              },
              editable: (params) => {
                return (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) ? true : false
              },
              cellStyle: (params) => {
                if ((TemplateType.find((a) => a.value === params?.data?.department?.type)?.name !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code))) {
                  return {
                    backgroundColor: 'lightgray',
                    border: 'none',
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
            };
          }
          if (col.field === 'itemcount') {
            return {
              ...col,
              cellRenderer: (params) => {
                return (
                  <span>{params?.data?.item_templates?.reduce((sum, i) => sum + Number(i.quantity || 0), 0) || 0}</span>
                )
              },
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
            };
          }
          if (col.field === 'department') {
            return {
              ...col,
              cellRenderer: (params) => {
                return (
                  <span>{params?.data?.department?.department_name || '--'}</span>
                )
              },
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
            };
          }
          if (col.field === 'templatetype') {
            return {
              ...col,
              cellRenderer: (params) => {
                return (
                  <span>{params?.data?.department?.type ? TemplateType.find((a) => a.value === params?.data?.department?.type)?.name : '--'}</span>
                )
              },
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
            };
          }
          if (col.field === 'creationdate') {
            return {
              ...col,
              cellRenderer: (params) => {
                return (
                  <span>{params?.data?.["created_at"] ? moment(params?.data?.["created_at"]).format('DD-MM-YYYY') : '--'}</span>
                )
              },
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
            };
          }
          if (col.field === 'budget') {
            return {
              ...col,
              flex: 1,
              minWidth: 175,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name === 'Mvedas') {
                  const total = params?.data?.item_templates.reduce((sum, item) => {
                    if (item.product?.list_price !== null && item.product?.list_price !== undefined) {
                      return sum + (item.quantity * item.product?.list_price);
                    }
                    return sum;
                  }, 0);
                  return (
                    <span>{`₹ ${params?.data?.item_templates ? Intl.NumberFormat('en-IN').format(total, 0) : 0}`}</span>
                  )
                } else {
                  const total = params?.data?.item_templates.reduce((sum, item) => {
                    if (item.list_price !== null && item.list_price !== undefined) {
                      return sum + (item.quantity * item.list_price);
                    }
                    return sum;
                  }, 0);
                  return (
                    <span>{`₹ ${params?.data?.item_templates ? Intl.NumberFormat('en-IN').format(total, 0) : 0}`}</span>
                  )
                }
              },
            };
          }
          if (col.field === 'exbudget') {
            return {
              ...col,
              flex: 1,
              minWidth: 175,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                const totalRooms = params?.data?.quantity;
                if (TemplateType.find((a) => a.value === params?.data?.department?.type)?.name === 'Mvedas') {
                  const totalBudget = params?.data?.item_templates.reduce((sum, item) => {
                    if (item.product?.list_price !== null && item.product?.list_price !== undefined) {
                      return sum + (item.quantity * item.product?.list_price);
                    }
                    return sum;
                  }, 0);
                  const result = totalRooms * totalBudget;
                  return (
                    <span>{`₹ ${totalBudget ? Intl.NumberFormat('en-IN').format(result) : 0}`}</span>
                  )
                } else {
                  const totalBudget = params?.data?.item_templates.reduce((sum, item) => {
                    if (item.list_price !== null && item.list_price !== undefined) {
                      return sum + (item.quantity * item.list_price);
                    }
                    return sum;
                  }, 0);
                  const result = totalRooms * totalBudget;
                  return (
                    <span>{`₹ ${totalBudget ? Intl.NumberFormat('en-IN').format(result) : 0}`}</span>
                  )
                }
              },
            };
          }
          if (col.field === 'thumbnail') {
            return {
              ...col,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.thumbnail) {
                  return (
                    <Box sx={{ height: '100%', width: '30px', display: 'flex', justifyContent: 'center' }}>
                      <img
                        src={params?.data?.thumbnail}
                        style={{ height: '100%', cursor: 'pointer' }}
                        alt="thumbnail"
                        onClick={() => {
                          setImageOpen(true);
                          setImageSrc(params?.data?.thumbnail);
                        }}
                      />
                    </Box>
                  );
                }
                return (
                  <ImageIcon style={{ color: 'lightgray' }} />
                );
              },
            };
          }
          return col;
        });
      }
    } else {
      column = DepartColumnDefs;
    }
    return column;
  }, [selectedRoom, templateItem, isChecked, indeterminate, productColumn, selectedData]);

  const getInitialData = async (pageNo, templateType, searchingText) => {
    setDataLoding(true);
    const url = [
      `/template/?userId=${user?.user_id}`,
      `organizationId=${user?.organization?.organization_id}`,
      `type=${templateType}`,
      `pageNo=${pageNo}`,
      `pageSize=100`,
      `${searchingText ? `searchText=${searchingText}` : ''}`
    ]
      .filter(Boolean)
      .join('&');
    try {
      const response = await apiRequest('get', url);
      const { data } = response.data;
      if (templateType === 'public') {
        setPublicTemplate(data?.sort((a, b) => a.department_name.localeCompare(b.department_name)));
      } else if (templateType === 'organization') {
        setOrganizationTemplate(data?.sort((a, b) => a.department_name.localeCompare(b.department_name)));
      } else {
        setPrivateTemplate(data?.sort((a, b) => a.department_name.localeCompare(b.department_name)));
      }
      setDataLoding(false);
    } catch (error) {
      setDataLoding(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  };

  const onGridReady = useCallback((params) => {
    if (params?.api) {
      const { api } = params;
      setGridApi(api);
      const dataSource = {
        rowCount: null,
        getRows: async (params) => {
          setDataLoding(true);
          const sortModel = params?.sortModel[0];
          const sortBy = {
            column: sortModel?.colId ?
              sortModel?.colId === 'bixpand_id' ? 'sku_no' :
                sortModel?.colId === 'cad_id' ? 'prefix' :
                  sortModel?.colId === 'Description' ? 'category_name' :
                    sortModel?.colId === 'department' ? 'department_name' :
                      sortModel?.colId : '',
            order: sortModel?.sort || '',
          };
          try {
            let lastRow = -1;
            if (templateItem !== null) {
              setActivePage(Math.floor((params.startRow / rowsPerPage) + 1));
              const response = await apiRequest('get',
                `/template/item?pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}&pageSize=${rowsPerPage}&roomIds=${templateItem.room_template_id}&sortBy=${sortBy.column}&sortOrder=${sortBy.order}`);
              const { data, total_count, total_cost, total_quantity } = response.data;
              if (data?.length <= total_count) {
                lastRow = total_count;
              }
              setListItem({
                total_count,
                total_cost,
                total_quantity
              });
              setReturnedData(data);
              setSelectedData([]);
              setIsChecked(false);
              params.successCallback(data, lastRow);
            } else if (selectedRoom?.length > 0) {
              const response = await apiRequest('get',
                `/template/room?pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}&pageSize=${rowsPerPage}&roomIds=${selectedRoom?.map((a) => a.room_template_id).toString()}&sortBy=${sortBy.column}&sortOrder=${sortBy.order}`);
              const { data, total_count, total_cost, total_quantity } = response.data;
              setListItem({
                total_cost,
                total_quantity
              });
              if (data?.length <= total_count) {
                lastRow = total_count;
              }
              params.successCallback(data, lastRow);
            } else {
              params.successCallback([], 0);
            }
            setDataLoding(false);
          } catch (error) {
            setDataLoding(false);
            showNotification(error?.response?.data.error || error.message, 'error');
          }
        }
      };
      api.setGridOption("datasource", dataSource);
      setTimeout(() => {
        const node = api.getRenderedNodes();
        if (!node?.[0]?.displayed) {
          api.showNoRowsOverlay();
        }
      }, 5000);
    };
  }, [rowsPerPage, selectedRoom, templateItem]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      onGridReady({
        api: gridApi,
      });
    }
    return () => {
      isMounted = false;
    };
  }, [rowsPerPage, selectedRoom, templateItem]);

  return (
    <Box component="main" sx={{ flexGrow: 1, p: !fromProject ? 3 : '0px 5px 0px 5px' }}>
      {dataLoading && <LoadingPage isLoading={dataLoading} />}
      {imageOpen && (
        <ImageModal
          imageSrc={imageSrc}
          open={imageOpen}
          onClose={() => {
            setImageOpen(false);
            setImageSrc('');
          }}
        />
      )}
      {itemOpen && (
        <CreateItem
          open={itemOpen}
          setOpen={setItemOpen}
          templateItem={templateItem}
          getData={(pageNo, type) => {
            getInitialData(pageNo, type);
            onGridReady({
              api: gridApi
            });
          }}
        />
      )}
      {openCopy && (
        <CommonCopy
          open={openCopy}
          setOpen={setOpenCopy}
          selectedItem={selectedRoom}
          selectedData={selectedData}
          getData={(pageNo, type) => {
            getInitialData(pageNo, type);
            setSelectedRoom([]);
            setSelectedDep([]);
            setSelectedData([]);
            setTemplateItem(null);
          }}
        />
      )}
      {open && (
        <CreateModule
          open={open}
          setOpen={setOpen}
          isTemplate={isTemplate}
          setIsTemplate={setIsTemplate}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          selectedDep={selectedDep}
          templateItem={templateItem}
          getData={(pageNo, type, data) => {
            getInitialData(pageNo, type);
            setSelectedDep((prevData) => prevData.filter((department) =>
              department.dept_template_id !== data?.dept_template_id
            ));
          }}
        />
      )}
      <Dialog open={deleteOpen} fullWidth maxWidth="xs">
        <DialogContent>{templateItem !== null ? 'Are you sure to delete item?' : selectedItem?.department_name ? `Are you sure to delete ${selectedItem?.department_name} template?` : `Are you sure to delete ${selectedItem?.room_name} room?`}</DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" color="secondary"
            onClick={() => {
              setSelectedItem(null);
              setDeleteOpen(false);
            }}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={async () => {
              try {
                setDataLoding(true);
                let response = '';
                if (templateItem !== null) {
                  response = await apiRequest('delete', `/template/item/${selectedData?.toString()}`);
                  if (response?.data) {
                    showNotification(response?.data?.message, 'success');
                    onGridReady({
                      api: gridApi,
                    });
                  }
                } else if (selectedItem?.dept_template_id) {
                  response = await apiRequest('delete', `/template/${selectedItem?.dept_template_id}`);
                  if (response?.data) {
                    showNotification(response?.data?.message, 'success');
                    setSelectedRoom((prevData) => prevData.filter((room) =>
                      room?.dept_template_id !== selectedItem.dept_template_id
                    ));
                    setSelectedDep(selectedDep.filter((a) => a.dept_template_id !== selectedItem.dept_template_id));
                  }
                } else {
                  response = await apiRequest('delete', `/template/room/${selectedItem?.room_template_id}`);
                  if (response?.data) {
                    showNotification(`${selectedItem?.room_name} is successfully deleted.`, 'success');
                    const updatedRoom = [...selectedRoom].filter(room =>
                      room.room_template_id !== selectedItem.room_template_id
                    );
                    setSelectedRoom(updatedRoom);
                    setSelectedDep((prevData) => prevData.map((department) =>
                      department.dept_template_id === selectedItem?.dept_template_id
                        ? {
                          ...department,
                          room_templates: updatedRoom,
                        }
                        : department
                    ));
                  }
                }
                setDataLoding(false);
                setSelectedItem(null);
                setSelectedData([]);
                setDeleteOpen(false);
                getInitialData(1, 'personal');
                getInitialData(1, 'public');
                getInitialData(1, 'organization');
              } catch (error) {
                setDataLoding(false);
                showNotification(error?.response?.data.error || error.message, 'error');
              }
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={copyOpen} fullWidth maxWidth="xs">
        <DialogTitle>Copy Template</DialogTitle>
        <DialogContent>
          <Box style={{ marginTop: '6px' }}>
            <Autocomplete
              value={TemplateType.find((c) => c.value === templateType) || null}
              id="combo-box-demo"
              size="small"
              fullWidth
              options={TemplateType}
              getOptionLabel={(option) => option?.name}
              getOptionDisabled={(option) => {
                if (option?.name === 'Mvedas') {
                  return !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code);
                }
                if (option?.name === 'Organization') {
                  return EnterpriseAccess !== currentPlanId && !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code);
                }
                return false;
              }}
              clearIcon={null}
              onChange={(event, newValue) => {
                setTemplateType(newValue?.value)
              }}
              renderInput={(params) => <TextField fullWidth {...params} label="Template Type" name="Template Type" variant="outlined" />}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" color="secondary"
            onClick={() => {
              setCopyOpen(false);
              setTemplateType(TemplateType[1]?.value);
            }}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={async () => {
              setDataLoding(true);
              const data = {
                dept_template_id: selectedDep[0]?.dept_template_id,
                department_name: `${selectedDep[0]?.department_name} - copy`,
                type: templateType,
                organization_id: user?.organization?.organization_id,
              }
              try {
                const response = await apiRequest('post', '/template/copy', data);
                if (response?.data) {
                  setDataLoding(false);
                  setSelectedDep([]);
                  setSelectedRoom([]);
                  setCopyOpen(false);
                  setTemplateType(TemplateType[1]?.value);
                  showNotification('Template data copied successfully', 'success');
                  getInitialData(1, 'public');
                  getInitialData(1, 'personal');
                  getInitialData(1, 'organization');
                }
              } catch (error) {
                setDataLoding(false);
                showNotification(error?.response?.data.error || error.message, 'error');
              }
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {!fromProject && (
        <>
          <DividerHeader />
          <DemoBox1>
            <Typography variant='h4' style={{ fontWeight: 'bold' }}>Templates</Typography>
            <DemoBox>
              {catalogOpen && (
                <AddItemInProject
                  catalogOpen={catalogOpen}
                  setCatalogOpen={setCatalogOpen}
                  selectedData={selectedData?.length > 0 ? selectedData : selectedRoom.length > 0 ? selectedRoom : selectedDep}
                  innerLabel={selectedData?.length > 0 ? 'Item' :
                    (selectedRoom.length > 0 && (Object.values(toggleStates?.Mvedas?.nested)?.some(value => value === true) ||
                      Object.values(toggleStates?.Personal?.nested)?.some(value => value === true) || Object.values(toggleStates?.Organization?.nested)?.some(value => value === true))) ?
                      'Room' :
                      selectedDep.length > 0 ? 'Department' : null
                  }
                  setSelectedData={() => {
                    setSelectedData([]);
                    onGridReady({
                      api: gridApi
                    })
                  }}
                  fromTemplate
                />
              )}
              <Button
                size="Medium"
                variant="outlined"
                startIcon={<CreateNewFolderOutlinedIcon />}
                disabled={selectedRoom.length === 0}
                onClick={() => {
                  setCatalogOpen(true);
                }}
              >
                Add To Project
              </Button>
              {(['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) || StandardAccess.includes(currentPlanId) || EnterpriseAccess === currentPlanId) && (
                <Button
                  size="Medium"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setOpen(true);
                    setIsTemplate(true);
                  }}
                >
                  Create Template
                </Button>
              )}
            </DemoBox>
          </DemoBox1>
          <Divider />
        </>
      )}
      <Grid container spacing={1} mt={!fromProject ? 0.2 : 0}>
        <Grid item xs={12} sm={4} md={3} lg={3} style={{ height: !fromProject ? '79vh' : '73vh', overflow: 'auto', borderRight: '1px solid lightgray' }}>
          <Box style={{ padding: '1px 5px' }}>
            <TextField
              size="small"
              id="outlined-search"
              type="text"
              placeholder="Search Templates"
              style={{
                background: '#ebeaea',
              }}
              fullWidth
              value={searchingText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  getInitialData(1, 'public', e.target.value);
                  getInitialData(1, 'personal', e.target.value);
                  getInitialData(1, 'organization', e.target.value);
                  setToggleStates((prevState) => {
                    const updatedState = { ...prevState };
                    updatedState["Mvedas"].open = true;
                    if (!updatedState["Mvedas"].open) {
                      updatedState["Mvedas"].nested = {};
                    }
                    updatedState["Personal"].open = true;
                    if (!updatedState["Personal"].open) {
                      updatedState["Personal"].nested = {};
                    }
                    updatedState["Organization"].open = true;
                    if (!updatedState["Organization"].open) {
                      updatedState["Organization"].nested = {};
                    }
                    return updatedState;
                  });
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: (
                  searchingText && (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setSearchText('');
                          getInitialData(1, 'public');
                          getInitialData(1, 'personal');
                          getInitialData(1, 'organization');
                        }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  )
                ),
              }}
            />
          </Box>
          {!fromProject && ((selectedRoom.length > 0 && (Object.values(toggleStates?.Mvedas?.nested)?.some(value => value === true) ||
            Object.values(toggleStates?.Personal?.nested)?.some(value => value === true) || Object.values(toggleStates?.Organization?.nested)?.some(value => value === true))) ? (
            <Box style={{ display: 'flex', justifyContent: 'end', paddingRight: 12 }}>
              {(['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) || StandardAccess.includes(currentPlanId) || EnterpriseAccess === currentPlanId) && (
                <Tooltip title="Copy Rooms">
                  <IconButton
                    style={{ padding: 2 }}
                    onClick={() => setOpenCopy(true)}
                  >
                    <ContentCopyOutlined color="primary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          ) : selectedDep.length === 1 && (
            <Box style={{ display: 'flex', justifyContent: 'end', paddingRight: 12 }}>
              {(['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) || StandardAccess.includes(currentPlanId) || EnterpriseAccess === currentPlanId) && (
                <Tooltip title="Copy Template">
                  <IconButton
                    style={{ padding: 2 }}
                    onClick={async () => {
                      setCopyOpen(true);
                    }}
                  >
                    <ContentCopyOutlined color="primary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          )
          )}
          {templates.map((template) => (
            <div key={template.label}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton style={{ padding: 0 }} onClick={() => handleToggle(template.label, template.key)}>
                  {toggleStates[template.label].open ? <ExpandMoreIcon /> : <KeyboardArrowRightIcon />}
                </IconButton>
                <span style={{ fontSize: '14px' }}>{template.label}</span>
              </div>
              <Collapse in={toggleStates[template.label].open} timeout="auto" unmountOnExit>
                {template.data?.map((a) => (
                  <Box key={a.department_name} style={{ marginLeft: 15 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 10 }}>
                      <div style={{ display: 'flex', alignItems: 'center', width: '78%' }}>
                        <IconButton style={{ padding: 0 }} onClick={() => handleToggle(template.label, a.key, a.department_name)}>
                          {toggleStates[template.label].nested[a.department_name] ? <ExpandMoreIcon /> : <KeyboardArrowRightIcon />}
                        </IconButton>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                indeterminate={selectedRoom?.filter((c) => c?.dept_template_id === a.dept_template_id)?.length > 0 ? selectedRoom?.filter((c) => c?.dept_template_id === a.dept_template_id)?.length < a?.room_templates?.length : false}
                                checked={[...selectedDep]?.some((c) => c.dept_template_id === a.dept_template_id)}
                              />}
                            label={<span style={{ fontSize: '14px' }}>{`${a.department_name} (${a?.room_templates?.reduce((sum, room) => sum + room.quantity, 0) || 0})`}</span>}
                            style={{ margin: 0 }}
                            onClick={async (e) => {
                              setTemplateItem(null);
                              const arr = [...selectedDep];
                              const newArr = [...selectedRoom];
                              if (e.target.checked) {
                                arr.push(a);
                                if (a.room_templates) {
                                  const roomArr = [
                                    ...newArr,
                                    ...a?.room_templates.map(template => ({
                                      ...template,
                                      dept_template_id: a.dept_template_id
                                    }))
                                  ];
                                  const uniqueArray = [
                                    ...new Set(
                                      roomArr.map((item) => JSON.stringify(item)),
                                    ),
                                  ].map((item) => JSON.parse(item));
                                  if (fromProject && innerLabel === 'Room') {
                                    setSelectedProduct(uniqueArray.map((a) => a.room_template_id));
                                  }
                                  setSelectedRoom(uniqueArray);
                                }
                              } else {
                                const index = arr.findIndex((c) => a.dept_template_id === c.dept_template_id);
                                if (index > -1) {
                                  arr.splice(index, 1);
                                }
                                setSelectedRoom([...newArr]?.filter((c) => c?.dept_template_id !== a.dept_template_id));
                                if (fromProject && innerLabel === 'Room') {
                                  setSelectedProduct([]);
                                }
                              }
                              setSelectedDep(arr);
                              if (fromProject && innerLabel === 'Department') {
                                setSelectedProduct(arr.map((a) => a.dept_template_id));
                              }
                            }}
                          />
                        </FormGroup>
                      </div>
                      <div>
                        {!fromProject && (
                          <>

                            {(template?.label !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) && (
                              <Tooltip title="Edit Template">
                                <IconButton
                                  style={{ padding: 2 }}
                                  onClick={() => {
                                    setOpen(true);
                                    setIsTemplate(true);
                                    setSelectedItem(a);
                                  }}
                                >
                                  <EditOutlined color="primary" />
                                </IconButton>
                              </Tooltip>
                            )}
                            {(template?.label !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) && (
                              <Tooltip title="Delete Template">
                                <IconButton
                                  style={{ padding: 2 }}
                                  onClick={() => {
                                    setDeleteOpen(true);
                                    setSelectedItem(a);
                                  }}
                                >
                                  <DeleteOutline color="secondary" style={{ fontSize: '28' }} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <Collapse in={toggleStates[template.label].nested[a.department_name]} timeout="auto" unmountOnExit>
                      {a.room_templates?.sort((a, b) => a.room_name.localeCompare(b.room_name))?.map((item) => (
                        <Box key={item.room_name} style={{ marginLeft: 15 }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 10 }}>
                            <div style={{ display: 'flex', alignItems: 'center', width: '78%' }}>
                              <IconButton style={{ visibility: 'hidden', padding: 0 }}>
                                {toggleStates[template.label].nested[a.department_name] ? <ExpandMoreIcon /> : <KeyboardArrowRightIcon />}
                              </IconButton>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={[...selectedRoom]?.some((a) => a?.room_template_id === item?.room_template_id)}
                                    />
                                  }
                                  label={<span style={{ fontSize: '14px' }}>{`${item.room_name} (${Number(item?.item_templates?.reduce((sum, i) => sum + Number(i.quantity), 0)) || 0})`}</span>}
                                  style={{ margin: 0 }}
                                  onClick={(e) => {
                                    setTemplateItem(null);
                                    const arr = [...selectedRoom];
                                    if (e.target.checked) {
                                      item.dept_template_id = a.dept_template_id;
                                      arr.push(item);
                                    } else {
                                      const index = arr.findIndex((a) => a.room_template_id === item?.room_template_id);
                                      if (index > -1) {
                                        arr.splice(index, 1);
                                      }
                                    }
                                    setSelectedRoom(arr);
                                    if (fromProject && innerLabel === 'Room') {
                                      setSelectedProduct(arr.map((a) => a.room_template_id));
                                    }
                                    const newArr = [...selectedDep];
                                    if (arr?.filter((c) => c.dept_template_id === a.dept_template_id)?.length === a?.room_templates?.length) {
                                      newArr.push(a);
                                    } else {
                                      const newIndex = newArr.findIndex((c) => c.dept_template_id === a.dept_template_id);
                                      if (newIndex > -1) {
                                        newArr.splice(newIndex, 1);
                                      }
                                    }
                                    setSelectedDep(newArr);
                                  }}
                                />
                              </FormGroup>
                            </div>
                            {!fromProject && (
                              <div>
                                {(template?.label !== 'Mvedas' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) && (
                                  <Tooltip title="Delete Room">
                                    <IconButton
                                      style={{ padding: 2 }}
                                      onClick={() => {
                                        setDeleteOpen(true);
                                        setSelectedItem(item);
                                      }}
                                    >
                                      <DeleteOutline color="secondary" style={{ fontSize: '28' }} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </div>
                            )}
                          </div>
                        </Box>
                      ))}
                    </Collapse>
                  </Box>
                ))}
              </Collapse>
            </div>
          ))}
        </Grid>
        {(selectedDep.length > 0 || selectedRoom?.length > 0) ? (
          <Grid item xs={12} style={{ padding: '8px 8px 0px 8px' }} sm={templateItem !== null ? 4 : 8} md={templateItem !== null ? 7 : 9} lg={templateItem !== null ? 7 : 9}>
            {selectedData?.length > 0 ? (
              <DemoBox1>
                <Typography>Selected Item: {selectedData?.length}</Typography>
                {!((StandardAccess.includes(currentPlanId) && templateItem.department?.type !== 'personal') || BasicAccess.includes(currentPlanId) || ((EnterpriseAccess === currentPlanId) && templateItem.department?.type === 'public')) && !fromProject && (
                  <Box>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setOpenCopy(true);
                      }}
                    >
                      <CopyAll />
                      <Typography color="primary" style={{ fontWeight: 600 }}>Copy</Typography>
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setDeleteOpen(true);
                      }}
                    >
                      <DeleteOutlineOutlined />
                      <Typography color="primary" style={{ fontWeight: 600 }}>Delete</Typography>
                    </IconButton>
                  </Box>
                )}
              </DemoBox1>
            ) :
              (<DemoBox1>
                <Box style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  {templateItem !== null && (
                    <Tooltip title="Back to template">
                      <ArrowBack style={{ cursor: 'pointer', fontSize: 20 }} onClick={() => {
                        setTemplateItem(null);
                      }} />
                    </Tooltip>
                  )}
                  <Typography variant='h4' style={{ fontWeight: 'bold' }}>{templateItem !== null ? templateItem?.room_name : (selectedDep?.length > 1 ? '# Department Templates' : selectedDep?.[0]?.department_name)}</Typography>
                </Box>
                {!fromProject && (
                  <DemoBox>
                    {templateItem !== null ? (
                      <Button
                        size="Medium"
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                          height: 39,
                        }}
                        onClick={() => {
                          setItemOpen(true);
                        }}
                        disabled={((StandardAccess.includes(currentPlanId) && templateItem.department?.type !== 'personal')) || BasicAccess.includes(currentPlanId) || ((EnterpriseAccess === currentPlanId) && templateItem.department?.type === 'public')}
                      >
                        Add Item
                      </Button>
                    ) : selectedDep.length === 1 && (selectedDep[0]?.type !== 'public' || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) && (<Button
                      size="Medium"
                      variant="contained"
                      startIcon={<AddIcon />}
                      style={{
                        height: 39,
                      }}
                      onClick={() => {
                        setOpen(true);
                        setIsTemplate(false);
                      }}
                    >
                      Create Room
                    </Button>
                    )}
                  </DemoBox>
                )}
              </DemoBox1>)}
            <Box style={{ display: 'flex', padding: '6px 10px', background: 'lightgray', gap: 10 }}>
              {templateItem !== null ? (
                <>
                  <Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}><SellIcon style={{ fontSize: 12 }} />{`Total Product Quantity: ${listItem?.total_count || 0} Products`}</Typography>
                  <Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}><TagIcon style={{ fontSize: 12 }} />{`Extended Item Quantity: ${listItem?.total_quantity || 0} Items`}</Typography>
                  <Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}><CurrencyRupeeIcon style={{ fontSize: 12 }} />
                    {`Total Cost: ₹ ${listItem?.total_cost ? Intl.NumberFormat('en-IN').format(listItem?.total_cost) : 0}`}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}><TagIcon style={{ fontSize: 12 }} />{`Total Template Rooms Quantity: ${listItem?.total_quantity || 0} Template Room(s)`}</Typography>
                  <Typography style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 2 }}><CurrencyRupeeIcon style={{ fontSize: 12 }} />
                    {`Total Cost: ₹ ${listItem?.total_cost ? Intl.NumberFormat('en-IN').format(listItem?.total_cost) : 0}`}
                  </Typography>
                </>
              )}
            </Box>
            <DataTable
              height={!fromProject ? "66.5vh" : "59vh"}
              columnDefs={updatedColumns}
              rowsPerPage={rowsPerPage}
              paginationPageSizeSelector={[10, 15, 25, 50, 100]}
              toolPanel={toolPanel}
              onPaginationChanged={onPaginationChanged}
              singleClickEdit={false}
              modelType="infinite"
              selectionType="multiple"
              fromTemplate={true}
              onColumnMoved={() => {
                if (templateItem !== null) {
                  setProductColumn(gridApi.getAllGridColumns().map((column) => column.getColDef()));
                }
              }}
              onGridReady={onGridReady}
              onSelectionChanged={() => {
                if (gridApi) {
                  const selectedNodes = gridApi.getSelectedNodes();
                  if (selectedNodes?.length < returnedData?.length * activePage) {
                    setIsChecked(false);
                    if (selectedNodes?.length === 0) {
                      setIndeterminate(false);
                    } else {
                      setIndeterminate(true);
                    }
                  } else {
                    setIsChecked(true);
                    setIndeterminate(false);
                  }
                  if (fromProject && innerLabel === 'Item') {
                    setSelectedProduct(selectedNodes.map((node) => node.data.item_template_id));
                  }
                  setSelectedData(selectedNodes.map((node) => node.data.item_template_id));
                }
              }}
              onCellValueChanged={async (event) => {
                const { data } = event;
                setDataLoding(true);
                if (templateItem !== null) {
                  const obj = {
                    status: 'active',
                    item_name: data?.item_name,
                    dept_template_id: data?.dept_template_id,
                    room_template_id: data?.room_template_id,
                    organization_id: user?.organization?.organization_id,
                    updated_by: user?.user_id,
                    quantity: Number(data?.quantity),
                    list_price: data?.list_price
                  }
                  try {
                    const response = await apiRequest('put', `/template/item/${data?.item_template_id}`, obj);
                    if (response?.data) {
                      setDataLoding(false);
                      showNotification(response?.data?.message, 'success');
                      onGridReady({
                        api: gridApi,
                      })
                    }
                  } catch (error) {
                    setDataLoding(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                  }
                } else {
                  data.status = 'active';
                  data.organization_id = user?.organization?.organization_id;
                  data.quantity = Number(data.quantity);
                  setSelectedRoom(prevData =>
                    prevData.map(room => {
                      if (room.room_template_id === data?.room_template_id) {
                        return { ...room, quantity: Number(data.quantity) };
                      }
                      return room;
                    })
                  );
                  try {
                    const response = await apiRequest('put', `/template/room/${data?.room_template_id}`, data);
                    if (response?.data) {
                      setDataLoding(false);
                      showNotification(response?.data?.message, 'success');
                      getInitialData(1, 'public');
                      getInitialData(1, 'personal');
                      getInitialData(1, 'organization');
                    }
                  } catch (error) {
                    setDataLoding(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                  }
                }
              }}
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={8} md={9} lg={9}>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%'
              }}>
              <TableViewIcon style={{ fontSize: 70 }} />
              <Typography style={{ marginTop: 10 }}>Choose a template to get started</Typography>
            </Box>
          </Grid>
        )}
        {templateItem !== null && (
          <Grid item xs={12} sm={4} md={2} lg={2} style={{ borderLeft: '1px solid lightgray' }}>
            {!fromProject && (
              <>
                <DemoBox style={{ marginBottom: '5px' }}>
                  <Button
                    size="Medium"
                    variant="contained"
                    startIcon={<Edit />}
                    style={{
                      height: 39,
                    }}
                    onClick={() => {
                      setOpen(true);
                      setIsTemplate(false);
                    }}
                    disabled={((StandardAccess.includes(currentPlanId) && templateItem.department?.type !== 'personal')) || BasicAccess.includes(currentPlanId) || ((EnterpriseAccess === currentPlanId) && templateItem.department?.type === 'public')}
                  >
                    Edit Room
                  </Button>
                </DemoBox>
                <Divider />
              </>
            )}
            <Box mt={1} mb={1}>
              <DemoTypo1 variant="body2">Description:</DemoTypo1>
              <Box style={{ height: '27.5vh', overflow: 'auto' }}>
                <DemoTypo variant="body2">{templateItem?.description}</DemoTypo>
              </Box>
            </Box>
            <Divider />
            <Box mt={1}>
              <DemoTypo1 variant="body2">Planning Tips:</DemoTypo1>
              <Box style={{ height: '27.5vh', overflow: 'auto' }}>
                <DemoTypo variant="body2">{templateItem?.planning_tips}</DemoTypo>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
      <Divider />
    </Box>
  )
}